import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import Home from './pages/Home';
import Login from './pages/Login';
import Registro from './pages/Registro';
import Equipo from './pages/Equipo';
import Ranking from './pages/Ranking';
import Ligas from './pages/Ligas';
import Resultados from './pages/Resultados';
import RankingLiga from './pages/RankingLiga';
import Verificar from './pages/Verificar';
import OlvidePassword from './pages/OlvidePassword';
import Restablecer from './pages/Restablecer';
import Pronosticos from './pages/Pronosticos';
import Admin from './pages/Admin';
import RutaProtegida from './components/RutaProtegida';
import Reglas from './pages/Reglas';
import Privacidad from './pages/Privacidad';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Login />} />
          <Route path="/registro" element={<Registro />} />
          <Route path="/reglas" element={<Reglas />} />
          <Route path="/privacidad" element={<Privacidad />} />
          <Route path="/equipo" element={<RutaProtegida><Equipo /></RutaProtegida>} />
          <Route path="/ranking" element={<RutaProtegida><Ranking /></RutaProtegida>} />
          <Route path="/ligas" element={<RutaProtegida><Ligas /></RutaProtegida>} />
          <Route path="/resultados" element={<Resultados />} />
          <Route path="/ranking-liga/:ligaId" element={<RutaProtegida><RankingLiga /></RutaProtegida>} />
          <Route path="/verificar/:token" element={<Verificar />} />
          <Route path="/olvide-password" element={<OlvidePassword />} />
          <Route path="/restablecer/:token" element={<Restablecer />} />
          <Route path="/pronosticos" element={<RutaProtegida><Pronosticos /></RutaProtegida>} />
          <Route path="/admin" element={<RutaProtegida soloAdmin><Admin /></RutaProtegida>} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
export default App;
